module.exports = __webpack_public_path__ + "img/Papua New Guinea.1626464d.svg";